var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass:
        "border-t border-gray-200 px-4 flex items-center justify-between sm:px-0",
    },
    [
      _c("div", { staticClass: "w-0 flex-1 flex" }, [
        _c(
          "a",
          {
            staticClass:
              "cursor-pointer -mt-px border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150",
            on: {
              click: function ($event) {
                return _vm.$emit("prev")
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "mr-3 h-5 w-5 text-gray-400",
                attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
                    "clip-rule": "evenodd",
                  },
                }),
              ]
            ),
            _vm._v(" Previous "),
          ]
        ),
      ]),
      _c("div", { staticClass: "hidden md:flex" }, [
        _c("div", [
          _c(
            "p",
            {
              staticClass:
                "-mt-px border-t-2 border-transparent pt-4 px-4 inline-flex items-center text-sm leading-5 font-medium text-gray-500",
            },
            [
              _vm._v(" Showing "),
              _c("span", { staticClass: "mx-1 font-medium" }, [
                _vm._v(_vm._s(_vm.resultFrom)),
              ]),
              _vm._v(" to "),
              _c("span", { staticClass: "mx-1 font-medium" }, [
                _vm._v(
                  _vm._s(_vm.resultTo > _vm.total ? _vm.total : _vm.resultTo)
                ),
              ]),
              _vm._v(" of "),
              _c("span", { staticClass: "mx-1 font-medium" }, [
                _vm._v(_vm._s(_vm.total)),
              ]),
              _vm._v(" results "),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "w-0 flex-1 flex justify-end" }, [
        _c(
          "a",
          {
            staticClass:
              "cursor-pointer -mt-px border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150",
            on: {
              click: function ($event) {
                return _vm.$emit("next")
              },
            },
          },
          [
            _vm._v(" Next "),
            _c(
              "svg",
              {
                staticClass: "ml-3 h-5 w-5 text-gray-400",
                attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
                    "clip-rule": "evenodd",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }